export interface TaskComment {
    id: string;
    text: string;
    timestamp: Date;
}

export interface Task {
    id: string;
    name: string;
    estimatedMinutes: number;
    elapsedSeconds: number;
    activeStartedAt?: Date;
    status: "pending" | "active" | "completed";
    createdAt: Date;
    completedAt?: Date;
    originalDate?: Date; // Preserves the original creation date when task is transferred to a new day
    isBacklog?: boolean; // True if task is in backlog, not assigned to a specific day
    pomodoroEnabled?: boolean; // Override global Pomodoro setting for this task
    pomodoroCount?: number; // Number of completed Pomodoro intervals for this task
    currentPomodoroElapsed?: number; // Seconds elapsed in current Pomodoro interval
    comments?: TaskComment[]; // Progress comments with timestamps
    tags?: string[]; // Task tags for categorization
}

export interface DailyStats {
    date: string; // ISO date string (YYYY-MM-DD)
    totalTasks: number;
    completedTasks: number;
    totalWorkedSeconds: number;
    totalEstimatedMinutes: number;
    completedPomodoros?: number; // Total Pomodoro intervals completed
}

export type TaskDestination = "today" | "backlog";

export interface PomodoroSettings {
    enabled: boolean; // Global Pomodoro mode toggle
    workDuration: number; // Work interval in minutes (default: 25)
    shortBreakDuration: number; // Short break in minutes (default: 5)
    longBreakDuration: number; // Long break in minutes (default: 15)
    intervalsBeforeLongBreak: number; // Number of work intervals before long break (default: 4)
}

export const DEFAULT_POMODORO_SETTINGS: PomodoroSettings = {
    enabled: false,
    workDuration: 25,
    shortBreakDuration: 5,
    longBreakDuration: 15,
    intervalsBeforeLongBreak: 4,
};

export interface ReflectionSettings {
    enabled: boolean; // Enable periodic reflection prompts
    intervalMinutes: number; // Interval in minutes between prompts (default: 5)
}

export const DEFAULT_REFLECTION_SETTINGS: ReflectionSettings = {
    enabled: false,
    intervalMinutes: 5,
};

export interface Particle {
    id: number;
    x: number;
    color: string;
    delay: number;
}
